import React from 'react';
import { Tag } from 'antd';
import ListEditItem from '../../../shared/ListEditItem';
import { getStatusColor } from '../../../../utils';
import { renderText } from '../../../shared/DrawerLayout/renderText';
import styles from '../UserInfo.styles';

interface UserManualApprovalInfoProps {
  selectedUser: any;
  intl: any;
  onEditManualApproval: () => void;
}

const UserManualApprovalInfo: React.FC<UserManualApprovalInfoProps> = ({
  selectedUser,
  intl,
  onEditManualApproval,
}) => {
  const manualApproval = selectedUser?.manualApproval;

  return (
    <div key={selectedUser?.id}>
      <div
        data-testid="UserManualApprovalInfo-title"
        className="user-section-title"
      >
        {intl.formatMessage({
          id: `fleetadmin.users.info.manualApproval`,
          defaultMessage: 'Manual Approval',
        })}
      </div>
      <ListEditItem
        label={intl.formatMessage({
          id: `fleetadmin.users.info.manualApproval.status`,
          defaultMessage: 'Manual Approval (Status)',
        })}
        leftItem={
          manualApproval && (
            <Tag
              data-testid="UserManualApprovalInfo-badge"
              color={getStatusColor(manualApproval)}
            >
              {intl.formatMessage({
                id: `fleetadmin.status.${manualApproval}`,
              })}
            </Tag>
          )
        }
        onClickEdit={onEditManualApproval}
      />
      <style jsx>{styles}</style>
    </div>
  );
};

export default UserManualApprovalInfo;
